<template>
    <Dialog :visible.sync="isExibirTela" :contentStyle="this.tamanhoTela ? `width: ${this.tamanhoTela}px;` : 'width: 400px'" 
        :header="tituloTela" :modal="true" class="tela-confirmacao">
        <div class="p-cardialog-content">
            <div class="p-grid p-fluid">

                <Rotulo :nome="textoConfirmcao" cols="12" />

            </div>
        </div>

        <template #footer>
            <Button :label="labelConfirmar ? labelConfirmar : 'Confirmar'" icon="pi pi-times" @click="confirmar" class="p-button-primary" />
            <Button :label="labelCancelar ? labelCancelar : 'Cancelar'" icon="pi pi-ban" @click="fecharTela" class="p-button-danger" />
        </template>
    </Dialog>
</template>

<script>
import Rotulo from './RotuloSeplag.vue'

export default {
    name: 'Confirmacao',
    components: { Rotulo },
    model: {
        prop: 'exibirTela',
        event: 'change'
    },
    props: {
        exibirTela: {
            // Propriedade utilizada para exibir a tela do diálogo do cadastro rápido
            type: Boolean,
            required: true
        },
        labelConfirmar: {
            type: String
        },  
        labelCancelar: {
            type: String
        },  
        textoConfirmcao: {
            type: String
        },
        tituloTela: {
            // Título a ser exibido na tela de cadastro rápido
            type: String,
            required: true
        },
        tamanhoTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        onConfirmar: {
            // Evento disparado para informar a adição do registro
            type: Function
        }
    },
    methods: {
        dimensaoTela(){
            return this.tamanhoTela ? `width: ${this.tamanhoTela}px;` : 'width: 400px'
        },
        confirmar(){
            // Fecha a janela
            this.fecharTela()
            // Dispara o evento de Confirmação pelo usuário
            this.onConfirmar()
        },
        fecharTela(){
            this.isExibirTela = !this.isExibirTela
        }
    },
    computed: {
        isExibirTela: {
            get(){
                return this.exibirTela
            },
            set(){
                // Emite uo evento personalizado para que seja modificado na origem
                this.$emit('change', !this.exibirTela)
            }
        }
    }
}
</script>

<style>
@media screen and (max-width: 40em) {
    .tela-confirmacao {
        width: 95% !important;
    }
}

</style>